import React from "react";

export { default as Header } from "./Header/Header";
export { default as Background } from "./GuaranteedIncome/Background";

export { default as IncomePlan } from "./GuaranteedIncome/IncomePlan";
export { default as Resultplan } from "./GuaranteedIncome/IncomePlan";
export { default as Benefits } from "./GuaranteedIncome/Benefits";
export { default as ResultBlock } from "./GuaranteedIncome/ResultBlock";
export { default as TalkToExpertModal } from "./Header/TalkToExpertModal";
export { default as KnowMoreModal } from "./GuaranteedIncome/KnowMoreModal";
export { default as ChartModal } from "./GuaranteedIncome/ChartModal";
export { default as SuitabilityModal } from "./Suitability/SuitabilityModal";
export { default as WhatIs } from "./WhatIs/WhatIs";
export { default as HowToCalc } from "./HowToCalc/HowToCalc";
export { default as CalculateAge } from "./Calculator/SubCalculator/CalculateAge";
export { default as CallUs } from "./callUs/CallUs";
export const PlanBenefits = React.lazy(
  () => import("./PlanBenefits/PlanBenefits"),
);
export const HowItWorks = React.lazy(() => import("./HowItWorks/HowItWorks"));
export const Steps = React.lazy(() => import("./Steps/Steps"));
export const StepsGuide = React.lazy(() => import("./StepsGuide/StepsGuide"));
export const PlanTypes = React.lazy(() => import("./PlanTypes/PlanTypes"));
export const ChoosePlan = React.lazy(() => import("./ChoosePlan/ChoosePlan"));
export const WhyUs = React.lazy(() => import("./WhyUs/WhyUs"));
export const Disclaimer = React.lazy(() => import("./Disclaimer/Disclaimer"));
export const FAQ = React.lazy(() => import("./FAQ/FAQ"));
